export default class VideoPlayer {
  constructor()
  {
    if (VideoPlayer.exists) {
      return VideoPlayer.instance;
    }
    VideoPlayer.instance = this;
    VideoPlayer.exists = true;

    this.ytApiReady = false;
    this.ytPlayers = {};
    this.observer = null;
    this.playOnIntoView = this.playOnIntoView.bind(this);
  }

  init()
  {
    this.videoEls = this.videoEls || document.querySelectorAll('.video-holder');

    if( ! this.videoEls) {
      return;
    }

    window.onYouTubeIframeAPIReady = () => {
      this.ytApiReady = true;
    };

    VideoPlayer.connectYtApi();

    this.videoEls.forEach( videoWrapper => {
      const { playerId, videoId } = videoWrapper.dataset;

      if( ! playerId || ! videoId ) {
        return;
      }

      if( 'view' === videoWrapper.dataset.playType  ) {
        if( ! this.observer ) {
          this.observer = new IntersectionObserver(this.playOnIntoView, {
            threshold: [0.5],
          })
        }

        this.observer.observe(videoWrapper);
      }

      const playButton = videoWrapper.querySelector('.btn-play');

      if( playButton ) {
        playButton.addEventListener('click', () => {
          this.mountYTVideo( playerId, videoId );
        });
      }
    })
  }

  setIds()
  {
    this.videoEls = this.videoEls || document.querySelectorAll('.video-holder');

    if( ! this.videoEls) {
      return;
    }

    this.videoEls.forEach( videoWrapper => {
      const id = Date.now().toString(36) + Math.random().toString(36).substr(2);
      videoWrapper.dataset.playerId = `player_${id}`;
      const iframe = videoWrapper.querySelector('.video-iframe');
      if(iframe) {
        iframe.setAttribute('id', `player_${id}`);
      }
    });
  }

  mountYTVideo( playerId, videoId ) {
    // let iframe = document.querySelector(`#${videoId}`);
    // if( ! iframe ) {
    //   return;
    // }

    if( ! this.ytApiReady ) {
      return;
    }

    let player;

    this.pauseAll();

    try {
      // check if player already initialised and if player exists, check if it has resumeVideo as a function
      if (this.ytPlayers[videoId] !== undefined) {

        this.ytPlayers[videoId].playVideo();
      } else {

        player = new YT.Player(playerId, {
          videoId,
          playerVars: {
            origin: palram.home_url,
            playsinline: 1,
            rel: 0,
          },
          events: {
            onReady: event => {
              // event.target is the YT player
              // get the actual DOM node iframe nad mark it as playing via a class, styling purposes, not necessary
              //event.target.getIframe().classList.add('playing');
              // play the video

              const holder = event.target.getIframe().closest('.video-holder');

              if (holder) {
                holder.classList.add('activated');
              }

              event.target.playVideo();

              if (5 === event.target.getPlayerState()) {
                //If unmuted autoplay not allowed mute
                event.target.mute();
                event.target.playVideo();
              }

            },
          },
        });

        // append to the list
        this.ytPlayers[videoId] = player;
      }
    } catch (e) {}
  }

  pauseAll()
  {
    try {
      let activePlayersKeys = Object.keys( this.ytPlayers );
      if (activePlayersKeys.length > 0) {
        // if players exist in the pool, pause them
        for (let i = 0; i < activePlayersKeys.length; i++) {
          this.pauseVideo(activePlayersKeys[i]);
        }
      }
    } catch (e) {}
  }

  pauseVideo = ( videoId ) => {
    try {
      if (!this.ytApiReady) {
        return;
      }
      if (this.ytPlayers[videoId] !== undefined && [1, 3].includes(this.ytPlayers[videoId].getPlayerState())) {
        this.ytPlayers[videoId].pauseVideo();
      }
    } catch (e) {}
  }

  playOnIntoView(entries) {
    try {
      entries.forEach( entry => {
        const { playerId, videoId } = entry.target.dataset;

        if( ! playerId ) {
          return;
        }

        if( ! entry.isIntersecting ) {
          this.pauseVideo(playerId);
        } else {
          this.mountYTVideo(playerId, videoId);
        }

      } );
    } catch (e) {}
  }

  static connectYtApi()
  {
    let ytScript = document.createElement('script');
    ytScript.src = 'https://www.youtube.com/iframe_api';
    document.querySelector('head')
      .appendChild(ytScript);
  }
}
